import React from "react";

const RegionsIcon = props => {
  const color = props.color;
  return (
    <svg width={22} height={22} viewBox="0 0 512 512" {...props}>
        <title>map</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="map" fill={color} fillRule="nonzero">
                <path d="M256,0 C189.832031,0 136,53.832031 136,120 C136,142.691406 142.371094,164.796875 154.429688,183.925781 L256,346 L357.570312,183.925781 C369.628906,164.796875 376,142.691406 376,120 C376,53.832031 322.167969,0 256,0 Z M256,180 C222.91875,180 196,153.08125 196,120 C196,86.9187504 222.91875,60 256,60 C289.08125,60 316,86.9187504 316,120 C316,153.08125 289.08125,180 256,180 Z" id="Shape"></path>
                <polygon id="Path" points="182.996094 512 328.953125 512 317.417969 421 194.242188 421"></polygon>
                <polygon id="Path" points="197.992188 391 248.90625 391 206.417969 323.613281"></polygon>
                <polygon id="Path" points="343.828125 391 462.003906 391 424.503906 301 332.285156 301"></polygon>
                <polygon id="Path" points="49.996094 391 167.761719 391 179.011719 301 87.496094 301"></polygon>
                <polygon id="Path" points="263.09375 391 313.570312 391 305.042969 324.476562"></polygon>
                <polygon id="Path" points="164.011719 421 37.496094 421 0 512 152.765625 512"></polygon>
                <polygon id="Path" points="474.503906 421 347.671875 421 359.210938 512 512 512"></polygon>
            </g>
        </g>
    </svg>
  );
};
export default RegionsIcon;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuIcons/RegionsIcon.js